module.exports = __webpack_public_path__ + "img/symphony_670_pink.b3bb8e59.jpg";